<template>
  <div>
    <div
      class="tw-flex tw-flex-col tw-mx-auto"
      style="max-width: 768px"
    >
      <h2 class="question-title-v2 tw-mb-4 tw-text-white">
        {{ question.title }}
      </h2>
      <p class="sub-text group-mb tw-mb-6 tw-text-white">
        {{ question.question }}
      </p>
      <div>
        <b-button
          v-if="question.answerlist && question.answerlist.length > 0"
          class="tw-px-6"
          variant="info"
          size="lg"
          @click="onSubmitFirst"
        >
          {{ question.answerlist[0].name }}
        </b-button>
        <b-button
          v-else
          class="tw-px-6"
          variant="info"
          size="lg"
          @click="onSubmitEmpty"
        >
          Complete
        </b-button>
        <div
          v-if="!hiddenLinkIds.includes(question.id)"
          class="tw-mt-6 tw-pt-1"
        >
          <a
            href="javascript:void(0)"
            class="text-underline text-uppercase tw-text-white"
            style="letter-spacing: 0.1rem"
          >
            Cancel my subscription
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    question: { type: Object, required: true },
  },
  data() {
    return { hiddenLinkIds: [12.1, 12.2] };
  },
  methods: {
    onSubmitFirst() {
      const a = this.question.answerlist[0];
      this.$emit('submitAnswer', { id: this.question.id, answer: a.id, answerBody: a });
    },
    onSubmitEmpty() {
      this.$emit('submitAnswer', { id: this.question.id, answer: '' });
    },
  },
};
</script>
